export default __webpack_public_path__ + "static/media/heart.23124022.svg";